export const PAGE_NAME = "login-page";
